import { connect } from 'react-redux';

import { push } from 'react-router-redux';

// components;
import SettingsTabBar from './SettingsTabBar';
import getOrganization from '../../../../lib/selectors/getOrganization';

// helpers
import getPathWithSearch from '../../../../helpers/getPathWithSearch';

const mapStateToProps = state => ({
  router:         state.get('router'),
  currentChapter: state.get('currentChapter'),
  currentUser:    state.get('currentUser'),
  organization:   getOrganization(state),
});

const mapDispatchToProps = dispatch => ({
  navigateToSettingsTab: (route, queryParams = {}) => {
    dispatch(push(getPathWithSearch(route, queryParams)));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(SettingsTabBar);
